import * as React from "react";
const SvgPetTransportation = (props) => /* @__PURE__ */ React.createElement("svg", { id: "svg3123", xmlSpace: "preserve", viewBox: "0 0 682.66669 682.66669", xmlns: "http://www.w3.org/2000/svg", xmlnsSvg: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("defs", { id: "defs3127" }, /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath3137" }, /* @__PURE__ */ React.createElement("path", { d: "M 0,512 H 512 V 0 H 0 Z", id: "path3135" }))), /* @__PURE__ */ React.createElement("g", { id: "g3129", transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)" }, /* @__PURE__ */ React.createElement("g", { id: "g3131" }, /* @__PURE__ */ React.createElement("g", { id: "g3133", clipPath: "url(#clipPath3137)" }, /* @__PURE__ */ React.createElement("g", { id: "g3139", transform: "translate(40.4385,61.2256)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 h 84.898 v -30.02 c 0,-11.395 -9.326,-20.721 -20.721,-20.721 H 20.722 C 9.326,-50.741 0,-41.415 0,-30.02 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3141" })), /* @__PURE__ */ React.createElement("g", { id: "g3143", transform: "translate(406.7607,61.2256)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 h -84.897 v -30.02 c 0,-11.395 9.326,-20.721 20.721,-20.721 h 43.455 C -9.325,-50.741 0,-41.415 0,-30.02 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3145" })), /* @__PURE__ */ React.createElement("g", { id: "g3147", transform: "translate(69.7773,256.2266)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 h -35.064 c -14.967,0 -27.213,-12.331 -27.213,-27.412 0,-15.08 12.246,-27.411 27.213,-27.411 h 9.467", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3149" })), /* @__PURE__ */ React.createElement("g", { id: "g3151", transform: "translate(406.21,256.2305)" }, /* @__PURE__ */ React.createElement("path", { d: "M 0,0 H 5.63 C 20.59,0 32.84,-12.33 32.84,-27.421 32.84,-42.5 20.59,-54.83 5.63,-54.83 h -9.5", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3153" })), /* @__PURE__ */ React.createElement("g", { id: "g3155", transform: "translate(357.5801,104.7959)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 h -49.012 c -19.728,0.425 -19.332,22.167 -5.555,30.757 l 29.197,18.141 c 13.606,8.448 43.54,14.855 43.54,-17.263 V 18.283 C 18.17,8.249 9.978,0 0,0 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3157" })), /* @__PURE__ */ React.createElement("g", { id: "g3159", transform: "translate(88.9678,104.7959)" }, /* @__PURE__ */ React.createElement("path", { d: "M 0,0 H 49.012 C 68.74,0.425 68.315,22.167 54.567,30.757 L 25.37,48.898 C 11.764,57.346 -18.17,63.753 -18.17,31.635 V 18.283 C -18.17,8.249 -9.978,0 0,0 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3161" })), /* @__PURE__ */ React.createElement("g", { id: "g3163", transform: "translate(262.0234,154.2051)" }, /* @__PURE__ */ React.createElement("path", { d: "M 0,0 H -75.997", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3165" })), /* @__PURE__ */ React.createElement("g", { id: "g3167", transform: "translate(244.7607,122.2295)" }, /* @__PURE__ */ React.createElement("path", { d: "M 0,0 H -41.442", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3169" })), /* @__PURE__ */ React.createElement("g", { id: "g3171", transform: "translate(380.8809,407.6016)" }, /* @__PURE__ */ React.createElement("path", { d: "M 0,0 C 9.014,0 16.384,10.432 16.384,23.187 16.384,35.944 9.014,46.376 0,46.376 -9.043,46.376 -16.385,35.944 -16.385,23.187 -16.385,10.432 -9.043,0 0,0 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3173" })), /* @__PURE__ */ React.createElement("g", { id: "g3175", transform: "translate(448.2041,423.0508)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 c -8.136,3.94 -19.276,-2.239 -24.804,-13.777 -5.555,-11.509 -3.458,-24.067 4.706,-27.979 8.163,-3.94 19.276,2.239 24.831,13.777 C 10.289,-16.441 8.163,-3.912 0,0 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3177" })), /* @__PURE__ */ React.createElement("g", { id: "g3179", transform: "translate(313.5293,423.0508)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 c 8.164,3.94 19.275,-2.239 24.832,-13.777 5.556,-11.509 3.43,-24.067 -4.706,-27.979 -8.164,-3.94 -19.275,2.239 -24.831,13.777 C -10.262,-16.441 -8.136,-3.912 0,0 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3181" })), /* @__PURE__ */ React.createElement("g", { id: "g3183", transform: "translate(380.541,323.0693)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 c -11.226,0 -12.388,-5.386 -21.714,-5.386 -22.876,0 -22.308,25.173 -10.318,36.285 l 18.822,17.406 c 4.365,4.082 8.787,6.093 13.21,6.093 4.422,0 8.815,-2.011 13.209,-6.093 L 32.003,30.899 C 44.021,19.787 44.589,-5.386 21.713,-5.386 12.387,-5.386 11.225,0 0,0 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3185" })), /* @__PURE__ */ React.createElement("g", { id: "g3187", transform: "translate(380.5127,501.5156)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 c 68.484,0 123.987,-55.504 123.987,-123.962 0,-68.487 -55.503,-123.991 -123.987,-123.991 -19.418,0 -37.814,4.478 -54.171,12.444 l -62.475,-13.465 15.023,54.001 c -14.088,20.099 -22.365,44.591 -22.365,71.011 C -123.988,-55.504 -68.457,0 0,0 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3189" })), /* @__PURE__ */ React.createElement("g", { id: "g3191", transform: "translate(257.8564,359.4395)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 h -77.868 c -3.883,0 -3.741,-0.624 -5.443,-3.94 l -18.028,-39.857", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3193" })), /* @__PURE__ */ React.createElement("g", { id: "g3195", transform: "translate(377.9893,253.5908)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 40.507,-86.8 c 5.755,-12.246 5.187,-11.509 5.187,-25.058 v -63.783 c 0,-9.184 -7.511,-16.724 -16.695,-16.724 h -166.366 m -34.612,0 H -338.43 c -9.183,0 -16.695,7.54 -16.695,16.724 v 63.783 c 0,13.549 -0.567,12.784 5.158,25.058 l 56.495,120.987 c 12.331,26.419 14.542,27.865 38.155,27.865 h 100.601 49.806", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3197" })), /* @__PURE__ */ React.createElement("g", { id: "g3199", transform: "translate(269.876,274.1426)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 h -145.985 c -0.652,-1.418 -1.247,-2.778 -1.786,-3.94 l -32.117,-68.799 h 116.023 m 34.611,0 H 86.684 L 56.551,-8.192", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path3201" }))))));
export default SvgPetTransportation;
